import styled from 'styled-components';
import media from 'src/styles/Media.styled';

export const Container = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    margin: 0;
    background: #140f4b 0% 0% no-repeat padding-box;
    opacity: 1;
    height: 100vh;

    ${media.mobileDevice`
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 0;
        margin-top: 0;
    `}
`;

export const ImageContainer = styled.div`
    width: 338px;
    height: 322px;

    ${media.mobileDevice`
        width: 228px;
        height: 84px;
    `}
`;

export const Image = styled.img`
    width: 256px;
    height: 256px;

    ${media.mobileDevice`
        width: 80px;
        height: 80px;
    `}
`;

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    margin-bottom: 60px;
`;

export const Header = styled.div`
    width: 233px;
    height: 65px;
    text-align: left;
    margin-bottom: 20px;

    ${media.mobileDevice`
        height: 65px;
    `}
`;

export const Logo = styled.img`
    width: 65%;
    height: 24px;
`;

export const ErrorTitle = styled.h1`
    width: 398px;
    height: max-content;
    font-size: 24px;
    line-height: 32px;
    color: #ffad00;
    font-family: 'AvenirNextWorld Demi', Arial, sans-serif;
    opacity: 1;
    text-align: left;
    margin: 0 0 16px 0;
    font-weight: 600;

    ${media.mobileDevice`
        width: 233px;
        font-size: 20px;
    `}
`;

export const ErrorMessage = styled.p`
    width: 400px;
    text-align: left;
    font-size: 16px;
    line-height: 24px;
    font-family: 'AvenirNextWorld Regular', Arial, sans-serif;
    color: #ededed;
    letter-spacing: -0.38px;
    opacity: 1;
    margin: 0 0 12px 0;

    ${media.mobileDevice`
        width: 233px;
        font-size: 15px;
    `}
`;

export const ErrorDetails = styled.p`
    width: 400px;
    text-align: left;
    font-size: 14px;
    line-height: 22px;
    font-family: 'AvenirNextWorld Thin', Arial, sans-serif;
    color: #ededed;
    letter-spacing: -0.38px;
    opacity: 1;
    margin: 0 0 20px 0;

    ${media.mobileDevice`
        width: 233px;
        font-size: 13px;
    `}
`;

export const ButtonText = styled.div`
    display: flex;
    align-items: center;
    height: 27px;
    text-align: left;
    font-family: 'AvenirNextWorld Regular', Arial, sans-serif;
    font-size: 14px;
    color: #ffffff;
    cursor: pointer;
    margin-right: 10px;
    white-space: nowrap;
`;